import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import Login from './components/Login';
import Register from './components/Register';
import BlogList from './components/BlogList';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Enteria" component={Login} />
          <Route path="/Regentix" component={Register} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/blogs" component={BlogList} />
          <Route path="/admin" component={AdminDashboard} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;